import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationKO from './locales/ko/translation.json';
import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';
import translationJA from './locales/ja/translation.json';
import translationTL from './locales/tl/translation.json';

const resources = {
  ko: { translation: translationKO },
  en: { translation: translationEN },
  zh: { translation: translationZH },
  ja: { translation: translationJA },
  tl: { translation: translationTL },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
